import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navigation content-width flex flex--halign-sb flex--valign-c" }
const _hoisted_2 = {
  ref: "refNavbar",
  class: "navbar navbar-expand-lg"
}
const _hoisted_3 = { class: "navbar-top" }
const _hoisted_4 = { class: "navbar-brand" }
const _hoisted_5 = {
  key: 0,
  class: "navbar-login"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "navbar-login-inner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLogo = _resolveComponent("HeaderLogo")
  const _component_GenericButton = _resolveComponent("GenericButton")

  return (_openBlock(), _createBlock("div", {
    ref: "refNavigationWrapper",
    class: [{ scrollDown: _ctx.scrolledTop >= 1, collapseOpen: _ctx.navbarOpen }, "navigation-wrapper fixed-top flex flex--halign-c"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("nav", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createVNode(_component_HeaderLogo, {
                "extra-title": _ctx.extraHeaderTitle,
                "logo-small": _ctx.scrolledTop >= 1
              }, null, 8, ["extra-title", "logo-small"])
            ])
          ]),
          (_ctx.showLogin)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_GenericButton, {
                  circular: "",
                  title: _ctx.$trans('navigation.nav_login'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickDashboard('/login')))
                }, null, 8, ["title"]),
                _createVNode(_component_GenericButton, {
                  circular: "",
                  secondary: "",
                  title: _ctx.$trans('navigation.nav_register'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickDashboard('/register')))
                }, null, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("button", {
            class: "navbar-toggler",
            type: "button",
            "aria-expanded": _ctx.navbarOpen,
            "aria-controls": "navbarNav",
            "aria-label": "Toggle navigation",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleNavbar && _ctx.toggleNavbar(...args)))
          }, [
            _hoisted_6
          ], 8, ["aria-expanded"])
        ]),
        _createVNode("div", {
          id: "navbarNav",
          ref: "refNavbarCollapse",
          class: ["navbar-collapse navbar-collapse-custom", { show: _ctx.navbarOpen }]
        }, [
          _createVNode("div", {
            class: "navbar-collapse-inner",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onNavbarInnerClick && _ctx.onNavbarInnerClick(...args)))
          }, [
            _renderSlot(_ctx.$slots, "default"),
            (_ctx.showLogin)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_GenericButton, {
                    circular: "",
                    small: "",
                    title: _ctx.$trans('navigation.nav_login'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickDashboard('/login')))
                  }, null, 8, ["title"]),
                  _createVNode(_component_GenericButton, {
                    circular: "",
                    small: "",
                    secondary: "",
                    title: _ctx.$trans('navigation.nav_register'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClickDashboard('/register')))
                  }, null, 8, ["title"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 512)
    ])
  ], 2))
}